export class RefreshEventArgs {
    public Type: string;
}
